<template>
  <div
    class="form-fw__header"
    :class="{ 'form-fw__header--shadow': shadow }"
  >
    <header>
      <v-layout align-center justify-start row>
        <v-flex xs2 md3>
          <v-btn class="mx-0" flat icon @click="prevPage">
            <v-icon color="gray-6">arrow_back</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs8 md6>
          <div class="text-xs-center">
            <h1 class="form-fw__header__title" >{{ $t(`${namespace}.nfeImportHistory`) }}</h1>
          </div>
        </v-flex>
      </v-layout>
    </header>
  </div>
</template>

<script>
import { goBack } from '@/utils/functions'

export default {
  name: 'RevenuesNfeImportHeader',
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      shadow: false
    }
  },
  methods: {
    prevPage () {
      goBack()
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
